var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVimeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 159.49 125.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-6{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#ff8f0b;stroke-width:6px;}.cls-3,.cls-6{stroke-miterlimit:10;}.cls-4{fill:#ff8f0b;}.cls-5{fill:#0b27ff;}.cls-6{stroke:#fff;stroke-width:5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 159.49,
    height: 125.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-3",
    x: 37.71,
    y: 3.63,
    width: 118.14,
    height: 118.14,
    rx: 38.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-4",
    d: "M105,102.29H88.55A31.34,31.34,0,0,1,57.21,71h0V54.47A31.34,31.34,0,0,1,88.55,23.13H105a31.34,31.34,0,0,1,31.35,31.33h0V70.94A31.35,31.35,0,0,1,105,102.29h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M90.26,62.71A45.13,45.13,0,1,1,45.13,17.58,45.14,45.14,0,0,1,90.26,62.71h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-5",
    d: "M78.24,62.71A33.12,33.12,0,1,1,45.13,29.59,33.11,33.11,0,0,1,78.24,62.71h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-6",
    d: "M78.24,62.71A33.12,33.12,0,1,1,45.13,29.59,33.11,33.11,0,0,1,78.24,62.71Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeIcon);
export default __webpack_public_path__ + "static/media/VimeIcon.2d9c09932944b4e81f411e52d2eda245.svg";
export { ForwardRef as ReactComponent };